export default __webpack_public_path__ + "static/media/avatar_female.c543c8fb.png";